import Adapt from "../directives/adapt.mjs";
import ClickOutside from "../directives/click-outside.mjs";
import Intersect from "../directives/intersect.mjs";
import Resize from "../directives/resize.mjs";
import Scroll from "../directives/scroll.mjs";
import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("adapt", Adapt);
  nuxtApp.vueApp.directive("click-outside", ClickOutside);
  nuxtApp.vueApp.directive("intersect", Intersect);
  nuxtApp.vueApp.directive("resize", Resize);
  nuxtApp.vueApp.directive("scroll", Scroll);
});
